export enum DateFilters {
  TRANSACTION_DATE = 'transactionDate',
  ORDER_DATE = 'orderDate',
}

export enum PaymentFilters {
  PAYMENT_STATUS = 'paymentStatus',
  PAYMENT_TYPE = 'paymentType',
}
